import React, {Component} from 'react';
import {connect} from "react-redux";

class EidStatus extends Component {

    render() {
        let status = null;

        if (!this.props.cardInserted && this.props.middlewareRunning) {
            status = (<span>{window.eidMessages.insertCard}</span>)
        }

        return (
            <div id="eid-status">
                {status}
            </div>
        )
    }

}

export default connect(
    (state) => {
        return {
            cardInserted: state.eid.inserted,
            middlewareRunning: state.eid.middlewareRunning
        }
    },
    (dispatch) => {
        return {

        }
    }
)(EidStatus);


// WEBPACK FOOTER //
// ./src/components/EidStatus.js